import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "panel"
}
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "col-md-8" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, " Summary ", -1)
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "card-text" }
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("hr", { class: "mt-4" }, null, -1)
const _hoisted_13 = { class: "col-md-6 gy-2" }
const _hoisted_14 = { class: "card mb-2" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, "Message", -1)
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_20 = { class: "card" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, "Activity Details", -1)
const _hoisted_22 = { class: "card-body" }
const _hoisted_23 = {
  key: 0,
  class: "card-text"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("abbr", { title: "{Activity.Name}" }, "Name", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("abbr", { title: "{Activity.ActivityType}" }, "Type", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("abbr", { title: "{Activity.Address}" }, "Address", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_30 = { class: "card-text" }
const _hoisted_31 = /*#__PURE__*/_createVNode("strong", null, "Event Location", -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("abbr", { title: "{Latitude}" }, "Latitude", -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("abbr", { title: "{Longitude}" }, "Longitude", -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_37 = {
  key: 1,
  class: "card-text"
}
const _hoisted_38 = /*#__PURE__*/_createVNode("strong", null, "Start Location", -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("abbr", { title: "{Activity.StartLocation.Notes}" }, "Notes", -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("abbr", { title: "{Activity.StartLocation.Address}" }, "Address", -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("abbr", { title: "{Activity.StartLocation.Latitude}" }, "Latitude", -1)
const _hoisted_45 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_46 = /*#__PURE__*/_createVNode("abbr", { title: "{Activity.StartLocation.Longitude}" }, "Longitude", -1)
const _hoisted_47 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_48 = { key: 0 }
const _hoisted_49 = /*#__PURE__*/_createVNode("abbr", { title: "{Activity.StartLocation.Floor}" }, "Floor", -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_51 = { key: 1 }
const _hoisted_52 = /*#__PURE__*/_createVNode("abbr", { title: "{Activity.StartLocation.Business}" }, "Business", -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_54 = { key: 2 }
const _hoisted_55 = /*#__PURE__*/_createVNode("abbr", { title: "{Activity.StartLocation.Apartment}" }, "Apartment", -1)
const _hoisted_56 = {
  key: 2,
  class: "card-text"
}
const _hoisted_57 = /*#__PURE__*/_createVNode("strong", null, "Panic Location", -1)
const _hoisted_58 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_59 = /*#__PURE__*/_createVNode("abbr", { title: "{Activity.PanicLocation.Address}" }, "Address", -1)
const _hoisted_60 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_61 = /*#__PURE__*/_createVNode("abbr", { title: "{Activity.PanicLocation.Latitude}" }, "Latitude", -1)
const _hoisted_62 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_63 = /*#__PURE__*/_createVNode("abbr", { title: "{Activity.PanicLocation.Longitude}" }, "Longitude", -1)
const _hoisted_64 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_65 = { class: "col-md-6 gy-2" }
const _hoisted_66 = { class: "card" }
const _hoisted_67 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, "Processing History", -1)
const _hoisted_68 = { class: "card-text" }
const _hoisted_69 = { class: "list-group list-group-flush" }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = {
  key: 0,
  class: "card-text"
}
const _hoisted_72 = /*#__PURE__*/_createVNode("strong", null, "Signal State", -1)
const _hoisted_73 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_74 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_75 = /*#__PURE__*/_createTextVNode(" Signal body: ")
const _hoisted_76 = { class: "text-wrap" }
const _hoisted_77 = /*#__PURE__*/_createVNode("hr", { class: "mt-4" }, null, -1)
const _hoisted_78 = { class: "row justify-content-center" }
const _hoisted_79 = { class: "col-md-4 text-center mb-3" }
const _hoisted_80 = /*#__PURE__*/_createTextVNode(" ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_block = _resolveComponent("error-block")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h1", null, _toDisplayString(_ctx.msg), 1),
    _createVNode(_component_error_block, { errors: _ctx.errors }, null, 8, ["errors"]),
    (_ctx.archive.ActivityUId)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode("div", _hoisted_7, [
                  _createVNode("p", _hoisted_8, [
                    _createTextVNode(" Activity UId: " + _toDisplayString(_ctx.archive.ActivityUId), 1),
                    _hoisted_9,
                    _createTextVNode(" Employee UId: " + _toDisplayString(_ctx.archive.EmployeeUId), 1),
                    _hoisted_10,
                    _createTextVNode(" Archive Date: " + _toDisplayString(_ctx.getHumanDate(_ctx.archive.ArchiveDate)), 1),
                    _hoisted_11
                  ])
                ])
              ])
            ])
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.archive.SheqsyEvents, (event, idx) => {
            return (_openBlock(), _createBlock("div", {
              class: "row",
              key: idx
            }, [
              _hoisted_12,
              _createVNode("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode("div", _hoisted_16, [
                    _createTextVNode(" Timestamp: " + _toDisplayString(_ctx.getHumanDate(event.Timestamp)), 1),
                    _hoisted_17,
                    _createTextVNode(" Message: " + _toDisplayString(event.Message), 1),
                    _hoisted_18,
                    _createTextVNode(" StatusCode: " + _toDisplayString(event.StatusCode), 1),
                    _hoisted_19
                  ])
                ]),
                _createVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode("div", _hoisted_22, [
                    (idx == 0)
                      ? (_openBlock(), _createBlock("p", _hoisted_23, [
                          _hoisted_24,
                          _createTextVNode(": " + _toDisplayString(event.Activity.Name), 1),
                          _hoisted_25,
                          _hoisted_26,
                          _createTextVNode(": " + _toDisplayString(event.Activity.ActivityType), 1),
                          _hoisted_27,
                          _hoisted_28,
                          _createTextVNode(": " + _toDisplayString(event.Activity.Address), 1),
                          _hoisted_29
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("p", _hoisted_30, [
                      _createVNode("a", {
                        href: 'https://www.google.com/maps/search/?api=1&query=' + event.Latitude + ',' + event.Longitude,
                        target: "_blank"
                      }, [
                        _hoisted_31
                      ], 8, ["href"]),
                      _hoisted_32,
                      _hoisted_33,
                      _createTextVNode(": " + _toDisplayString(event.Latitude), 1),
                      _hoisted_34,
                      _hoisted_35,
                      _createTextVNode(": " + _toDisplayString(event.Longitude), 1),
                      _hoisted_36
                    ]),
                    (event.Activity.StartLocation)
                      ? (_openBlock(), _createBlock("p", _hoisted_37, [
                          _createVNode("a", {
                            href: 'https://www.google.com/maps/search/?api=1&query=' + event.Activity.StartLocation.Latitude + ',' + event.Activity.StartLocation.Longitude,
                            target: "_blank"
                          }, [
                            _hoisted_38
                          ], 8, ["href"]),
                          _hoisted_39,
                          _hoisted_40,
                          _createTextVNode(": " + _toDisplayString(event.Activity.StartLocation.LocationNotes), 1),
                          _hoisted_41,
                          _hoisted_42,
                          _createTextVNode(": " + _toDisplayString(event.Activity.StartLocation.Address), 1),
                          _hoisted_43,
                          _hoisted_44,
                          _createTextVNode(": " + _toDisplayString(event.Activity.StartLocation.Latitude), 1),
                          _hoisted_45,
                          _hoisted_46,
                          _createTextVNode(": " + _toDisplayString(event.Activity.StartLocation.Longitude), 1),
                          _hoisted_47,
                          (event.Activity.StartLocation.Floor)
                            ? (_openBlock(), _createBlock("span", _hoisted_48, [
                                _hoisted_49,
                                _createTextVNode(": " + _toDisplayString(event.Activity.StartLocation.Floor), 1),
                                _hoisted_50
                              ]))
                            : _createCommentVNode("", true),
                          (event.Activity.StartLocation.Business)
                            ? (_openBlock(), _createBlock("span", _hoisted_51, [
                                _hoisted_52,
                                _createTextVNode(": " + _toDisplayString(event.Activity.StartLocation.Business), 1),
                                _hoisted_53
                              ]))
                            : _createCommentVNode("", true),
                          (event.Activity.StartLocation.Apartment)
                            ? (_openBlock(), _createBlock("span", _hoisted_54, [
                                _hoisted_55,
                                _createTextVNode(": " + _toDisplayString(event.Activity.StartLocation.Apartment), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (event.Activity.PanicLocation)
                      ? (_openBlock(), _createBlock("p", _hoisted_56, [
                          _createVNode("a", {
                            href: 'https://www.google.com/maps/search/?api=1&query=' + event.Activity.PanicLocation.Latitude + ',' + event.Activity.PanicLocation.Longitude,
                            target: "_blank"
                          }, [
                            _hoisted_57
                          ], 8, ["href"]),
                          _hoisted_58,
                          _hoisted_59,
                          _createTextVNode(": " + _toDisplayString(event.Activity.PanicLocation.Address), 1),
                          _hoisted_60,
                          _hoisted_61,
                          _createTextVNode(": " + _toDisplayString(event.Activity.PanicLocation.Latitude), 1),
                          _hoisted_62,
                          _hoisted_63,
                          _createTextVNode(": " + _toDisplayString(event.Activity.PanicLocation.Longitude), 1),
                          _hoisted_64
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_65, [
                _createVNode("div", _hoisted_66, [
                  _hoisted_67,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(event.CorrelationEvents, (correlation, index) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "card-body",
                      key: index
                    }, [
                      _createVNode("p", _hoisted_68, [
                        _createVNode("ul", _hoisted_69, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(correlation.ReceiverAction, (action, index) => {
                            return (_openBlock(), _createBlock("li", {
                              class: ["list-group-item", ['list-group-item', action.Result ? 'list-group-item-success' : 'list-group-item-danger']],
                              key: index
                            }, [
                              _createTextVNode(_toDisplayString(action.ReceiverStatus) + " @ " + _toDisplayString(_ctx.getHumanDate(action.Generated)), 1),
                              (action.GeneratedArtefacts > 1)
                                ? (_openBlock(), _createBlock("span", _hoisted_70, " " + _toDisplayString(action.GeneratedArtefacts) + " signals", 1))
                                : _createCommentVNode("", true)
                            ], 2))
                          }), 128))
                        ])
                      ]),
                      (correlation.Signal)
                        ? (_openBlock(), _createBlock("p", _hoisted_71, [
                            _hoisted_72,
                            _createTextVNode(": " + _toDisplayString(correlation.Signal.State), 1),
                            _hoisted_73,
                            _createTextVNode(" Delivery Attempts: " + _toDisplayString(correlation.Signal.Attempts), 1),
                            _hoisted_74,
                            _hoisted_75,
                            _createVNode("pre", _hoisted_76, _toDisplayString(correlation.Signal.Body), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ])
            ]))
          }), 128)),
          _hoisted_77,
          _createVNode("div", _hoisted_78, [
            _createVNode("div", _hoisted_79, [
              _createVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getDownload(_ctx.archive.id))),
                class: "btn btn-outline-primary"
              }, "Download"),
              _hoisted_80,
              _createVNode("button", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteArchive(_ctx.archive.id))),
                class: "btn btn-outline-danger"
              }, "Purge")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}